module.exports = __webpack_public_path__ + "img/avatar.cf5e7b2b.png";